import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env';
import { IPartnerSource } from '@core/interfaces/partner/partner-source.interface';
import { IContact } from '@core/interfaces/contact/contact.interface';
import { HttpService, IPartnerConfig } from '@interticket/core';
import { IOnlinePartner } from '@core/interfaces/partner/online-partner.interface';

@Injectable()
export class PartnerSourceService implements IPartnerSource {

  private readonly serviceBaseUrl: string = `/${environment.modules.core.partner.version}/iam-management`;
  private readonly serviceBaseUrlV2: string = `/${environment.modules.core.regionPartner.version}/iam-management`;

  constructor(
    private httpService: HttpService
  ) { }

  getConfig(): Observable<IPartnerConfig> {
    return this.httpService.get<IPartnerConfig>(`${this.serviceBaseUrlV2}/partner/me/config`);
  }

  getContacts(): Observable<IContact[]> {
    return this.httpService.get<IContact[]>(`${this.serviceBaseUrl}/partner/web/me/contacts`);
  }

  getOnlinePartnerList(): Observable<IOnlinePartner[]> {
    return this.httpService.get<IOnlinePartner[]>(`${this.serviceBaseUrlV2}/region-partner/web/partner`);
  }

}
